import { render, staticRenderFns } from "./AppInput.vue?vue&type=template&id=31baedc8&scoped=true&"
import script from "./AppInput.vue?vue&type=script&lang=js&"
export * from "./AppInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31baedc8",
  null
  
)

export default component.exports